import { render, staticRenderFns } from "./cookie.vue?vue&type=template&id=6af746ae&scoped=true"
import script from "./cookie.vue?vue&type=script&setup=true&lang=js"
export * from "./cookie.vue?vue&type=script&setup=true&lang=js"
import style0 from "./cookie.vue?vue&type=style&index=0&id=6af746ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af746ae",
  null
  
)

export default component.exports